import React from 'react';
import PropTypes from 'prop-types';

import {_} from 'utils/i18n';

import Row from 'scripts/components/Row';
import Column from 'scripts/components/Column';
import BaseModal from 'scripts/components/Modal';

import Footer from './Footer';
import ReasonSelect from './ReasonSelect';

const Text = _('Please chose a reason why you want to abort:');

const Modal = ({title, onCancel, ...props}) => {
    const footer = <Footer {...props} onCancel={onCancel} />;

    return (
        <BaseModal title={title} onDismiss={onCancel} footer={footer} fixedFooter>
            <Row>
                <Column size={12}>
                    <p className="info">{Text}</p>
                </Column>
            </Row>
            <form id="support-form">
                <ReasonSelect {...props} />
            </form>
        </BaseModal>
    );
};

Modal.propTypes = {
    ...Footer.propTypes,
    ...ReasonSelect.propTypes,
    title: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default Modal;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonAbortModal/Modal.js